var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "field-section",
    class: [_vm.backgroundColor ? 'layout-with-background' : 'layout-without-background', {
      'small-spacing1': !_vm.spacing && _vm.paragraph[0].text
    }, {
      'small-spacing2': !_vm.spacing && !_vm.paragraph[0].text
    }],
    style: {
      'background-color': _vm.backgroundColor
    }
  }, [_c('div', {
    staticClass: "d-flex col-11 col-md-7 flex-column align-items-md-center text-md-center mx-auto"
  }, [_c('title-section', {
    attrs: {
      "title": _vm.title,
      "text-color": _vm.titleColor
    }
  }), _vm._v(" "), _c('subtitle-section', {
    attrs: {
      "subtitle": _vm.subtitle,
      "text-color": _vm.subtitleColor
    }
  }), _vm._v(" "), _c('simple-paragraph', {
    style: {
      'color': _vm.paragraphColor
    },
    attrs: {
      "paragraph": _vm.paragraph,
      "has-read-more": _vm.readMore
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "block-cta"
  }, _vm._l(_vm.buttons, function (button, key) {
    return _c('cta', _vm._b({
      key: key,
      staticClass: "mb-3 mr-3",
      nativeOn: {
        "click": function click($event) {
          return _vm.$root.$emit('generic-tracking', $event, button.tracking);
        }
      }
    }, 'cta', button.props, false));
  }), 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };